export default __webpack_public_path__ + "static/media/Gloves of the Farseeker.cabca1f7.jpg";